import * as api from '../api';

export const get = async athleteId =>
    await api.get(`/2.0/coach/admin/athlete/${athleteId}`);

export const getAll = async requestingUserId =>
    await api.get(`/2.0/coach/admin/coachAthletes/${requestingUserId}`);

export const getAllInvited = async () => await api.get('/v5/athletes/invites');



// WEBPACK FOOTER //
// ./src/api/service/athleteService.js